import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum TrainingSummaryStep {
  Summary = 'Summary',
}

export const trainingSummaryFlow: CheckinWorkflow<TrainingSummaryStep> = {
  id: FlowId.TrainingSummary,
  entry: TrainingSummaryStep.Summary,
  steps: {
    [TrainingSummaryStep.Summary]: {
      id: TrainingSummaryStep.Summary,
      page: PageKey.TRAINING_SUMMARY,
      next: () => ({ complete: true }),
      back: () => ({ bubble: 'back' }),
      exit: () => ({ bubble: 'exit' }),
    },
  },
};
